<template>
	<div>
		<el-row>
			<el-col :span="24">
				<el-card shadow="none" style="border-radius: 12px">
					<el-row >
						<el-col :span="6" :offset="6">
							<h2>Raise Action </h2>
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Location </el-col>
						<el-col :span="8">
							{{ location }}
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Category </el-col>
						<el-col :span="8">
							{{ category }}
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Form </el-col>
						<el-col :span="8">
							{{ form }}
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Step </el-col>
						<el-col :span="8">
							{{ step }}
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Priority </el-col>
						<el-col :span="8">
							{{ priority }}
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Describe Issue </el-col>
						<el-col :span="8">
							<el-input
								type="textarea"
								:rows="2"
								placeholder="Add Description"
								v-model="description"
								class="input-class"
								v-validate="'required'"
								name="Add Description"
							>
							</el-input>
							<p>
								<span
									:v-show="errors.has(`Add Description`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Add Description`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="8" :offset="9">
							<el-button
								class="button-class-white"
								icon="el-icon-upload"
								@click="$refs.fileUploadSelector.click()"
							>
								Upload Files
							</el-button>
							<input
								multiple
								:maxlength="5"
								type="file"
								@change="upload_file_handler"
								ref="fileUploadSelector"
								style="display: none"
							/>
						</el-col>
					</el-row>
					<el-row style="margin-top: 10px" v-if="fileURLArray">
						<el-col style="margin-right: 20px" :span="15" :offset="9">
							<el-row>
								<el-col
									:span="2"
									:offset="1"
									v-for="(item, idx) in fileURLArray"
									:key="idx"
								>
									<div style="cursor: pointer">
										<el-tooltip
											class="item"
											v-if="item.fileDetails.type.includes('image')"
											effect="light"
											content="Click to show image"
											placement="bottom"
										>
											<img
												:src="item.src"
												@click="show_excel(item.src)"
												style="height: 50px"
											/>
										</el-tooltip>
										<el-tooltip
											v-if="item.fileDetails.type == 'application/pdf'"
											class="item"
											effect="light"
											content="Click to show pdf"
											placement="bottom"
										>
											<img
												style="height: 50px"
												@click="show_excel(item.src)"
												src="../../../../assets/icons/pdf.png"
											/>
										</el-tooltip>
										<el-tooltip
											v-if="
												item.fileDetails.type.includes('csv') ||
												item.fileDetails.type.includes('sheet')
											"
											class="item"
											effect="light"
											content="Click to show excel"
											placement="bottom"
										>
											<img
												style="height: 50px"
												@click="show_excel(item.src)"
												src="../../../../assets/icons/excel.png"
											/>
										</el-tooltip>
										<div class="text-right">
											<i
												@click="fileURLArray.splice(idx, 1)"
												class="el-icon-delete"
											/>
										</div>
									</div>
								</el-col> 
							</el-row>
						</el-col>
					</el-row>
					<el-row style="margin-top: 40px">
						<el-col :span="3" :offset="6"> Due Date </el-col>
						<el-col :span="8">
							<el-date-picker
								style="margin-top: 10px"
								v-model="due_date"
								type="date"
								placeholder="Select Due Date"
								class="date"
								format="yyyy-MM-dd"
								v-validate="'required'"
								name="Select Due Date"
								:picker-options="datePickerOptions"
							>
							</el-date-picker>
							<p>
								<span
									:v-show="errors.has(`Select Due Date`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Due Date`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</el-col>
					</el-row>
					<el-row style="margin-top: 120px; margin-bottom: 60px">
						<el-col :span="3" :offset="20">
							<el-button
								@click="nextStep()"
								class="button-class"
								style="width: 150px"
							>
								Update
							</el-button>
						</el-col>
					</el-row>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import formBuilderServices from "../../../../services/formBuilderServices";
var moment = require("moment");

export default {
	props: {
		formDetails: Object,
		locations: String,
		locationItems: Array,
		category_name: Array,
		current_obj: Object,
	},
	data: () => ({
		due_date: "",
		location: "",
		category: "",
		form: "",
		step: "",
		priority: "",
		issue: "",
		filesArray: [],
		filesPreviewArray: [],
		fileURLArray: [],
		description: "",
		uploadedAttachments: [],
		datePickerOptions: {
			firstDayOfWeek: 1,
			disabledDate(time) {
				return time < moment().subtract(0, "days");
			},
		},
	}),
	mounted() {
		console.log("formDetails", this.formDetails);
		console.log("locations", this.locations);
		console.log("locationsItems", this.locationItems);
		console.log("category", this.category_name);
		for (let i = 0; i < this.locationItems.length; i++) {
			if (this.locationItems[i].id == this.locations) {
				this.location = this.locationItems[i].name;
			}
		}
		this.category = this.category_name[0].form_category_info.name;
		this.form = this.formDetails.form_info.name;
		this.step = this.current_obj.form_question_info.name;
		this.priority = this.current_obj.form_question_info.is_critical
			? "Yes"
			: "No";
	},
	methods: {
		nextStep() {
			this.$validator.validateAll().then((result) => {
				if (result) {
			let issue_attachments = [];
			if (this.uploadedAttachments.length != 0) {
				for (let i = 0; i < this.uploadedAttachments.length; i++) {
					issue_attachments.push({
						file_name: this.uploadedAttachments[i].file_name,
						file_path: this.uploadedAttachments[i].file_path,
						serial_no: i + 1,
					});
				}
			}
			let params = {
				action: {
					form_question_execution: this.current_obj.id,
					issue_description: this.description,
					resolved_description: "",
					due_date: moment(this.due_date).format("YYYY-MM-DD"),
					status: "in_progress",
				},
				issue_attachments: issue_attachments,
				resolved_attachments: [],
			};
			formBuilderServices.taskAction(params).then((res) => {
				console.log(res, "resppp");
				this.$notify.success({
					title: "Success",
					message: "Ticket Updated Successfully",
					type: "Success",
				});
				this.$emit("close", this.description, this.current_obj);
			});
		} else {
						alert("Enter required fields");
					}})
		},
		upload_file_handler(event) {
			if (event.target.files && event.target.files.length) {
				this.filesArray = event.target.files;
				let obj = {};
				if (this.filesArray.length + this.fileURLArray.length <= 5) {
					for (let i = 0; i < this.filesArray.length; i++) {
						obj = {
							fileDetails: this.filesArray[i],
							src: URL.createObjectURL(this.filesArray[i]),
						};
						this.filesPreviewArray.push(obj);
					}
					this.fileURLArray = this.filesPreviewArray;
					console.log(this.fileURLArray, "url");
					const formData = new FormData();
					for (let i = 0; i < this.filesArray.length; i++) {
						formData.append("attachments", this.filesArray[i]);
					}
					console.log(formData);
					formBuilderServices.uploadQuestionAttachment(formData).then((res) => {
						this.uploadedAttachments = JSON.parse(res.data).data;
						console.log(this.uploadedAttachments, "eeeeeeeeeeeee");
						// this.add_question_attachments_api();
					});
				} else {
					alert("cannot upload more than 5 file");
				}
			}
		},
	},
};
</script>

<style></style>
